__turbopack_context__.v({
  "className": "DSvspW_className",
});
